import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import DashboardLoadingState from "./DashboardLoadingState";

export default function ProtectedRoute({ children }) {
  const { user, loading, error } = useAuth();
  const location = useLocation();

  if (loading) {
    return <DashboardLoadingState fullPage label="Preparando WebProfit…" />;
  }

  if (!user) {
    return (
      <Navigate
        to="/login"
        state={{
          from: location,
          message: error || undefined,
          messageSeverity: error ? "error" : undefined,
        }}
        replace
      />
    );
  }

  return children;
}
